module.exports = __webpack_public_path__ + "img/Gold.f8c0c9fa.png";